<template>
  <v-row justify="center">
    <v-dialog v-model="show" :max-width="isMobile ? '400px': '800px'" persistent>
      <v-card>
        <v-card-title style="justify-content: center;">{{$t('order.relaunchOrder')}}</v-card-title>
        <v-card-text>
          <v-card-text class="pb-0">{{$t('order.relaunchOrderText')}}</v-card-text>
          <v-row justify='center' class='mt-1 mb-3'>
            <a target="_blank"
               style="text-transform: none;text-decoration: underline;"
               @click="showOtherWorkflows = !showOtherWorkflows"
            >
              {{$t('order.selectWorkflowBelow')}}
            </a>
          </v-row>
          <v-row justify='center' class='mt-1'>
            <v-autocomplete
              v-if="showOtherWorkflows"
              v-model="selectedChoice"
              :items="workflows"
              :label="$t('order.workflows')"
              :no-data-text="$t('orderWorkflow.noActivatedWorkflow')"
              :item-text="item => item.fullDisplayLabel"
              item-value="value"
              clearable
              dense
              hide-details
              outlined
              :loading="loading"
              required>
              <template #item="{ item }">
                <v-tooltip right>
                  <template #activator="{ on, attrs }">
                    <div v-bind="attrs" v-on="on">{{ item.displayLabel }}</div>
                  </template>
                  <span>{{ item.fullDisplayLabel }}</span>
                </v-tooltip>
              </template>
            </v-autocomplete>
          </v-row>
        </v-card-text>
        <v-card-actions class="pa-0">
          <v-btn
            color="primary"
            tile
            style="width: 50%"
            @click="confirm()"
          >{{$t('subOrder.confirm')}}</v-btn>
          <v-btn
            color="secondary"
            class="ml-0"
            style="width: 50%"
            tile
            @click="close()"
          >{{$t('subOrder.close')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>


<script>
export default {
  name: "WorkflowSChoiceDialog",
  data() {
    return {
      selectedChoice: undefined,
      showOtherWorkflows: false
    };
  },
  props: {
    title: {
      type: String,
      default: undefined 
    },
    introductionSentence: {
      type: String,
      default: undefined
    },
    value: {
      type: Boolean,
      default: false
    },
    choices: {
      type: Array,
      required: true,
    },
    choicesListLabel: {
      type: String,
      default: undefined
    },
    noChoiceText: {
      type: String,
      default: undefined
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value)
      }
    },
    isMobile() {
      return this.$vuetify.breakpoint.width < 650
    },
    workflows() {
      return this.choices.map((workflow) => {
        return {
          fullDisplayLabel: workflow.name + ' (' + workflow._id + ')',
          displayLabel: this.truncateText( workflow.name )+ ' (' + workflow._id + ')',
          value: workflow._id }
      })
    }
  },
  methods: {
    confirm: function() {
      let valueToEmit = this.selectedChoice ? this.selectedChoice : false
      this.$emit("confirm", valueToEmit)
      this.show = false
    },
    close(){
      this.$emit("close")
      this.show = false
    },
    truncateText(text) {
      const maxLength = this.isMobile ? 40 : 60
      return text.length > maxLength ? text.slice(0, maxLength) + "..." : text
    },
  }
};
</script>